export enum ChampsInformationComplementaire {
  DescriptionSommaire,
  Prealables,
  Concomitants,
  Substitution,
  Positionnement,
  RestrictionsInscription,
  RenseignementsSupplementaires,
}
